import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useEffect, useState } from "react";

/**
 * Ko dopire do izabrane baze.
 *
 * Ovo je jedini put do tog podatka koji NE traži da korisnik krene u opasnu
 * radnju. Do sada se sastav pristupa video samo kroz dijalog za skidanje sa
 * spiska — dakle da bi PROČITAO stanje, morao je da otvori brisanje.
 *
 * Učitava se sámo, na promenu baze: pregled koji traži klik da bi se popunio
 * nije pregled nego još jedno dugme.
 */
export const useDatabaseAccess = (database) => {
    const [access, setAccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selected: { selectedServer }, userData, URL } = useContext(GuiContext);

    const load = useCallback(async () => {
        if (!database || !selectedServer) {
            setAccess(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`${URL}/api/database/access`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    database,
                    server_url: selectedServer,
                    guiname: userData?.guiname,
                }),
            });
            const body = await res.json();
            if (body?.status === false) throw new Error(body.message || "Could not read who has access.");
            setAccess(body);
        } catch (err) {
            // Prazan pregled uz grešku, ne prazan spisak: „ne znam" i „nema
            // nikoga" se na ovom ekranu ne smeju izjednačiti.
            setAccess(null);
            setError(err.message || "Could not read who has access.");
        } finally {
            setLoading(false);
        }
    }, [database, selectedServer, userData?.guiname, URL]);

    useEffect(() => { load(); }, [load]);

    return { access, loading, error, reload: load };
};
